import script from "./UserImgAtom.vue?vue&type=script&setup=true&lang=js"
export * from "./UserImgAtom.vue?vue&type=script&setup=true&lang=js"

import "./UserImgAtom.vue?vue&type=style&index=0&id=1b49d952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b49d952"]])

export default __exports__